import Instruction from "components/base/Instruction/Instruction";

export default Instruction;
